"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MASK_WORD = exports.piiMasks = void 0;
const mask_1 = require("./mask");
const types_1 = require("./types");
exports.piiMasks = {
    [types_1.MASK_OPTIONS.DEFAULT]: mask_1.defaultPiiMaskJson.maskProperties.map((prop) => prop.toLowerCase())
};
exports.MASK_WORD = 'REDACTED';
//# sourceMappingURL=constants.js.map